<div class="order-item-container">
  <div class="header mb-3" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <div>
      <span class="order-label">سفارش:‌ </span>
      <span class="type"> {{ getType() }} - 
        <span class="print-size">{{ getPrintSize() }}</span>
    </span>
    </div>
    <!-- <div class="price">
      <div class="span" *ngIf="+orderObject.price !== 0">
        {{ orderObject.price | irc : "T" | digitsEnToFa }}
      </div>
    </div> -->
    <app-order-status-badge [order]="orderObject"></app-order-status-badge>
  </div>

  <div class="content" *ngIf="orderObject.type !== 'thesis-edit'">
    <!-- <section class="print-type">{{ getPrintType() }}</section> -->

    <div
      class="information"
      fxLayout="row"
      style="width: 100%"
      fxLayoutAlign="space-between center"
    >
      <div class="info" fxFlex="100" fxLayoutAlign="row wrap">
        <span class="pages-number">
          {{ this.orderObject.pageCount + " صفحه " | digitsEnToFa }} /
        </span>
        <span class="bw-pages-number" *ngIf="bwBlocks && bwBlocks.length > 0">
          {{ bwBlocks.length + " صفحه سیاه و سفید " | digitsEnToFa }} / 
        </span>
        <span
          class="colorful-pages-number"
          *ngIf="colorFulBlocks && colorFulBlocks.length > 0"
        >
          {{ colorFulBlocks.length + " صفحه تمام رنگی " | digitsEnToFa }} /
        </span>

        <span
          class="halfColorful-pages-number"
          *ngIf="halfColorBlocks && halfColorBlocks.length > 0"
        >
          {{ halfColorBlocks.length + " صفحه نیمه رنگی " | digitsEnToFa }} /
        </span>

        <span class="binding" *ngIf="orderObject.binding">
          {{ orderObject.binding.name }}
        </span>
      </div>
    </div>
  </div>

  <div
    class="actions-status"
    *ngIf="actionsOn"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
  >
    <!-- <div class="status" [ngClass]="orderObject.status">
      {{ getDisplayStatus() }}
    </div> -->

    <!-- <div
      class="copies-number-controller"
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
    >
      <button
        matRipple
        class="increase"
        (click)="runAction('increaseCopy')"
        class="btn increase-btn"
      >
        +
      </button>
      <span class="printNumber">{{
        orderObject.copiesNumber | digitsEnToFa
      }}</span>
      <button
        (click)="runAction('decreaseCopy')"
        matRipple
        class="decrease"
        class="btn decrease-btn"
      >
        <span *ngIf="orderObject.copiesNumber > 1"> - </span>
        <jam-icon
          name="trash"
          *ngIf="orderObject.copiesNumber === 1"
          matTooltip="حذف سفارش"
        ></jam-icon>
      </button>
    </div> -->
    <div class="footer">
      <div class="price-count-controller">
        <div class="price" *ngIf="+orderObject.price !== 0">
          {{ orderObject.price | irc : "TOMAN" | digitsEnToFa }}
        </div>
        <div
          fxLayout="row wrap"
          fxLayoutAlign="space-between center"
        >
          <div
            class="copies-number-controller"
            fxLayout="row wrap"
            fxLayoutAlign="space-between center"
          >
            <button
              matRipple
              class="increase"
              (click)="runAction('increaseCopy')"
              class="btn increase-btn"
              matTooltip="افزایش تعداد"
            >
              <mat-icon svgIcon="plus"></mat-icon>
            </button>
            <span class="printNumber">{{
              orderObject.copiesNumber | digitsEnToFa
            }}</span>
            <button
              (click)="runAction('decreaseCopy')"
              matRipple
              class="decrease"
              class="btn decrease-btn"
              [disabled]="orderObject.copiesNumber === 1"
              matTooltip="کاهش تعداد"
            >
              <span><mat-icon svgIcon="minus"></mat-icon></span>
            </button>
          </div>
          <!-- <jam-icon
            name="trash"
            [size]="18"
            color="warn"
            matTooltip="حذف سفارش"
          ></jam-icon> -->
          <button class="mr-2" mat-icon-button aria-label="Delete Order" (click)="runAction('decreaseCopy', true)" matTooltip="حذف سفارش" style="width: initial !important; height: 34px !important;">
            <mat-icon svgIcon="trash-alt" class="warn"></mat-icon>
          </button>
          <!-- <button class="edit" (click)="editOrder()" mat-button color="primary">
      ویرایش
    </button> -->
        </div>
      </div>
    </div>
    <!-- <button class="edit" (click)="editOrder()" mat-button color="primary">
      ویرایش
    </button> -->
  </div>
</div>
